import { ErrorCode } from "@playcharge/common/models/backend/error-code";
import { computed } from "@angular/core";
import { signalStoreFeature, withComputed, withState } from "@ngrx/signals";

export enum RequestState {
    Idle = 0,
    Pending = 1,
    Fulfilled = 2,
}

export type RequestStatus = RequestState | { error: ErrorCode };

export type RequestStatusState = { requestStatus: RequestStatus };

export function withRequestStatus() {
    return signalStoreFeature(
        withState<RequestStatusState>({ requestStatus: RequestState.Idle }),
        withComputed(({ requestStatus }) => ({
            isPending: computed(() => requestStatus() === RequestState.Pending),
            isFulfilled: computed(() => requestStatus() === RequestState.Fulfilled),
            error: computed(() => {
                const status: RequestStatus = requestStatus();

                return typeof status === "object" ? status.error : null;
            }),
        })),
    );
}

export function setPending(): RequestStatusState {
    return { requestStatus: RequestState.Pending };
}

export function setFulfilled(): RequestStatusState {
    return { requestStatus: RequestState.Fulfilled };
}

export function setError(error: ErrorCode): RequestStatusState {
    return { requestStatus: { error } };
}
